import OutlinedView from './OutlinedView';

export { default as OutlinedView } from './OutlinedView';
export default OutlinedView;